




























































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";

@Component
export default class Ui extends Vue {
    items = [
        { age: 40, first_name: "Dickerson", last_name: "Macdonald" },
        { age: 21, first_name: "Larsen", last_name: "Shaw" },
        { age: 89, first_name: "Geneva", last_name: "Wilson" },
        { age: 38, first_name: "Jami", last_name: "Carney" }
    ];

    fields = [
        "age",
        "first_name",
        "last_name",
        {
            key: "actions",
            label: ""
        }
    ];
}
